import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faPlus, faRotateRight } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import Calendar from '../components/Calendar';
import { toast } from 'react-toastify';
import { reservations } from '../apiServices/apiServices';
import CustomToastContainer from './../components/CustomToastContainer';
import ItemTicket from '../components/ItemTicket';

export default function CalendarReservationsUI() {
  const navigate = useNavigate();
  const [userData, setUserData] = useState({});
  const [reservationsData, setReservationsData] = useState([]);
  const [selectedDateReservaion, setSelectedDateReservaion] = useState([]);
  const [bookDates, setBookDates] = useState([]);

  const today = new Date();
  const currentMonth = today.getMonth();
  const currentYear = today.getFullYear();
  const fromMonth = new Date(currentYear, currentMonth - 1, 1);
  const toMonth = new Date(currentYear, currentMonth + 1, 1);

  const handleNavigation = (path) => {
    navigate(path);
  };

  // const handleDateSelect = (date) => {
  //   console.log('Selected Date:', date);
  // };

  const handleDateSelect = (date) => {
    console.log('Selected Date:', date);

    // Format the selected date to match the format used in reservations
    const selectedDate = date.toLocaleDateString("en-CA");

    // Filter the reservations for the selected date
    const filteredReservations = reservationsData.filter(reservation => {
      const reservationDate = new Date(reservation.start_date.split(" ")[0]).toLocaleDateString("en-CA");
      return reservationDate === selectedDate;
    });

    setSelectedDateReservaion(filteredReservations);
    // Log or display the filtered reservations
    if (filteredReservations.length > 0) {
      console.log('Reservations for selected date:', filteredReservations);
    } else {
      console.log('No reservations for this date.');
    }
  };

  useEffect(() => {
    const user = window.localStorage.getItem("user");
    // console.log("User : ", user);
    if (user) {
      const parsedUser = JSON.parse(user);
      setUserData(parsedUser);
      reservationsMethod(parsedUser.id);
    } else {
      setUserData({});
    }
  }, []);

  const reservationsMethod = async (userId) => {
    try {
      const response = await reservations(userId);
      if (response?.success) {
        const reservationList = response.data.reservations;
        setReservationsData(reservationList);
  
        const uniqueBookingDates = getUniqueBookingDates(reservationList, fromMonth, toMonth);

        console.log("Booking Dates", uniqueBookingDates);
        // Set the unique dates in the state
        setBookDates(uniqueBookingDates);
      }
    } catch (error) {
      console.error('Error:', error);
      toast.error('An error occurred. Please try again.');
    }
  };
  
  const getUniqueBookingDates = (reservationList, fromMonth, toMonth) => {
    // Set the date range to compare and format it
    fromMonth.setHours(0, 0, 0, 0);
    toMonth.setHours(0, 0, 0, 0);
  
    // Format the from and to months as strings in YYYY-MM-DD format
    const fromMonthString = fromMonth.toLocaleDateString("en-CA");
    const toMonthString = toMonth.toLocaleDateString("en-CA");
  
    // Extract and filter the reservation dates
    const dateStrings = reservationList
      .map(item => {
        const date = new Date(item.start_date.split(" ")[0]);
        const formattedDate = date.toLocaleDateString("en-CA");
  
        // Return the formatted date if it is within the range, otherwise return undefined
        return (formattedDate >= fromMonthString && formattedDate < toMonthString) ? formattedDate : undefined;
      })
      .filter(Boolean); // Remove undefined values
  
    // Get unique date strings
    const uniqueDateStrings = [...new Set(dateStrings)];
  
    return uniqueDateStrings;
  };
  
  
  return (
    <div className="bg-gray-100 h-screen flex flex-col relative overflow-hidden">
      {/* Navigation Bar */}
      <nav className="flex items-center justify-between p-2 sm:p-4 bg-white shadow-md fixed top-0 left-0 right-0 z-10">
        <button className="text-gray-600 flex items-center" onClick={() => handleNavigation(-1)}>
          <FontAwesomeIcon icon={faArrowLeft} size="lg" />
        </button>
        <div className="flex items-center gap-2">
          <h1 className="text-gray-600 font-semibold text-lg text-center">
            My Seat Bookings
          </h1>
        </div>
        <button className="text-gray-600 flex items-center" onClick={() => window.location.reload()}>
          <FontAwesomeIcon icon={faRotateRight} size="lg" />
        </button>
      </nav>

      {/* Main Content */}
      <div className="flex-1 flex flex-col md:flex-row mt-10 md:mt-16 overflow-hidden">
        {/* Calendar */}
        <div className="w-full md:w-1/2 md:flex md:justify-center md:items-center p-2 md:p-4">
          <Calendar fromMonth={fromMonth} toMonth={toMonth} bookingDates={bookDates} onDateSelect={handleDateSelect} />
        </div>

        {/* Divider */}
        <hr className="md:hidden" />

        {/* Reservations */}
        <div className="flex-1 w-full md:w-1/2 mx-auto overflow-y-auto mb-12 md:mb-10">
          {selectedDateReservaion.length === 0 ? (
            <div className="md:min-h-screen flex items-center justify-center p-6 text-center">
              <h3 className="text-sm md:text-base font-semibold text-gray-600">No reservations for this date</h3>
            </div>
          ) : (
            <div className="p-2 md:p-4">
              {selectedDateReservaion.slice().reverse().map((reservation) => (
                <ItemTicket
                  key={reservation.reservation_id}
                  routeName={reservation.route_name}
                  passengerName={reservation.fullName}
                  gender={reservation.gender}
                  pickupStopName={reservation.pickup_stop_name}
                  dropoffStopName={reservation.dropoff_stop_name}
                  seatNo={reservation.seat_no}
                  bookingDate={reservation.start_date}
                  pickupLat={reservation.pickup_lat}
                  pickupLon={reservation.pickup_long}
                  dropOffLat={reservation.dropoff_lat}
                  dropOffLon={reservation.dropoff_long}
                  pickupStopId={reservation.pickup_stop_id}
                  dropoffStopId={reservation.dropoff_stop_id}
                  routeId={reservation.route_id}
                />
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Bottom Button */}
      <div className="bg-white flex justify-center items-center fixed bottom-0 left-0 right-0 z-10">
        <button
          className="w-5/6 mt-2 mb-2 px-2 py-3 border font-semibold border-[#BE1F18] text-[#BE1F18] hover:bg-[#BE1F18] hover:text-white text-base rounded cursor-pointer"
          onClick={() => handleNavigation('/allRoutes')}
        >
          <FontAwesomeIcon icon={faPlus} size="sm" /> Book Seats
        </button>
      </div>

      <CustomToastContainer />
    </div>

  );
}
